module.exports = __webpack_public_path__ + "img/37-CapitalPresent.d36833fa.jpg";